import { useState } from "react";
import { useLocation, Link } from "react-router-dom";
import { MessageSquare, X, Maximize2 } from "lucide-react";
import { CoachChat } from "@/components/CoachChat";

export const CoachWidget = () => {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();
  if (pathname.startsWith("/admin") || pathname.startsWith("/coach")) return null;
  return (
    <>
      {open && (
        <div
          className="fixed bottom-24 right-4 sm:right-6 z-[71] w-[calc(100vw-2rem)] sm:w-[380px] h-[460px] bg-night border border-white/20 shadow-2xl flex flex-col overflow-hidden"
          data-testid="coach-panel"
        >
          <div className="flex items-center justify-between px-4 py-3 border-b border-white/10 shrink-0">
            <div>
              <p className="font-display text-lg leading-none">NRC COACH</p>
              <p className="font-mono-label text-white/40 mt-1">TRAINING · GEAR · CLUBS</p>
            </div>
            <div className="flex items-center gap-1">
              <Link to="/coach" aria-label="Open full coach page" data-testid="coach-expand" className="p-2 text-white/50 hover:text-white transition-colors duration-200">
                <Maximize2 size={15} />
              </Link>
              <button onClick={() => setOpen(false)} aria-label="Close coach" data-testid="coach-close" className="p-2 text-white/50 hover:text-white transition-colors duration-200">
                <X size={17} />
              </button>
            </div>
          </div>
          <CoachChat compact />
        </div>
      )}
      <button
        onClick={() => setOpen((v) => !v)}
        aria-label="Chat with NRC Coach"
        data-testid="coach-bubble"
        className="fixed bottom-6 right-4 sm:right-6 z-[70] w-14 h-14 bg-white text-ink border border-white flex items-center justify-center hover:bg-night hover:text-white transition-colors duration-200 shadow-xl"
      >
        {open ? <X size={22} /> : <MessageSquare size={22} />}
      </button>
    </>
  );
};
